// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDhoCdYkOxIy4-lGHSVH_sOX_JO26mq39Y",
    authDomain: "relead-dev.firebaseapp.com",
    databaseURL: "https://relead-dev.firebaseio.com",
    projectId: "relead-dev",
    storageBucket: "relead-dev.appspot.com",
    messagingSenderId: "455444197524",
    appId: "1:455444197524:web:0e3157897d1d0eaa2f4481",
    measurementId: "G-N4P835EYVE"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
